import { useState } from 'react';
import NextImage from 'next/image';
import tractiveProductStackImage from 'shared/assets/brands/tractive/product-stack-photoroom.png';
import tractiveProductStackWebp from 'shared/assets/brands/tractive/product-stack-photoroom.webp';

export function TractiveProductImage({ alt }: { alt: string }) {
  const [hasWebpError, setHasWebpError] = useState(false);

  return (
    <picture className={'relative block aspect-square w-full'}>
      {!hasWebpError && <source type="image/webp" srcSet={tractiveProductStackWebp.src} />}
      <NextImage
        src={tractiveProductStackImage}
        alt={alt}
        className={'object-contain object-bottom'}
        fill
        unoptimized
        loading="lazy"
        sizes="(min-width: 768px) 208px, 144px"
        onError={() => setHasWebpError(true)}
      />
    </picture>
  );
}
